<template>
  <footer class="elevation-2">
    <v-footer class="white">
      <v-row>
        <v-col
          cols="9"
          align="left"
          align-self="center"
          class="pb-0"
        >
          <ul class="list-inline">
            <li
              v-for="link in links"
              :key="link.link"
            >
              <router-link
                text
                class="my-2 fz14 ttu tdn"
                :to="link.href"
              >
                {{ link.link }}
              </router-link>
            </li>
          </ul>
        </v-col>
        <v-col
          cols="3"
          align="right"
          class="d-flex flex-row-reverse pb-0"
        >

          <a href="https://github.com/goochtech" target="_blank">
            <v-img
              src="@/assets/images/icons8-github.svg"
              height="25"
              width="25"
              class="ma-1"
            ></v-img>
          </a>

          <!-- <a href="https://upwork.com" target="_blank">
            <v-img
              src="@/assets/images/icons8-upwork.svg"
              height="25"
              width="25"
              class="ma-1"
            ></v-img>
          </a> -->
          <a href="https://linkedin.com/in/chrisgoochconsulting" target="_blank">
            <v-img
              src="@/assets/images/icons8-linkedin.svg"
              height="25"
              width="25"
              class="ma-1"
            ></v-img>
          </a>
        </v-col>
        <v-col
          cols="12"
          align="left"
          class="pa-0 pl-3"
        >
          <p class="pl5 fz12 c-navt ttu mt10">Copyright &copy; Chris Gooch. All Rights Reserved.</p>
        </v-col>
      </v-row>
    </v-footer>
</footer>
</template>

<style lang="scss" scoped>
.list-inline {
  padding-left: 0;
  list-style: none;

  li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
  }
  a {
    color: #999;
  }
  a:hover {
    text-decoration: underline;
  }

}

</style>

<script>
  export default {
    data: () => ({
      links: [
        {link: 'Home', href: '/'},
        {link: 'Blog', href: '/blog'},
        {link: 'Contact', href: '/contact'},
      ],
    }),
  }
</script>